import api from './../index';

export const getVersion = async userEmail => {
  const res = await api();
  return res.get(`version/getVersion/`).then(res => {
    console.log('API version:', res.data);
    return res.data;
  });
};
